import { ProActions, ProActionTypes } from '../actions/pro.actions';

export interface CalculateProNodesState {
  isLoaded: boolean;
  isLoading: boolean;
  Nodes: number;
}

export const initialCalculateProNodesState: CalculateProNodesState = {
  isLoaded: false,
  isLoading: false,
  Nodes: 0
};

export function CalculateProNodesReducer(state = initialCalculateProNodesState, action: ProActions): CalculateProNodesState {
  switch (action.type) {

    case ProActionTypes.CalculateProNodes:
      return {...state, isLoading: true, isLoaded: false };

    case ProActionTypes.CalculateProNodesSuccess:
      return {...state, isLoading: false, isLoaded: true, Nodes: action.payload }; // nodes: action.payload
    default:
      return state;
  }
}

export interface ProNodesBankState {
  isLoaded: boolean;
  isLoading: boolean;
  entities: any;
}

export const initialProNodesBankState: ProNodesBankState = {
  isLoaded: false,
  isLoading: false,
  entities: null
};

export function ProNodesBankReducer(state = initialProNodesBankState, action: ProActions):
 ProNodesBankState {
  switch (action.type) {

    case ProActionTypes.GetProNodesBank:
      return {...state, isLoading: true, isLoaded: false };
    case ProActionTypes.GetProNodesBankSuccess:
      return {...state, isLoading: false, isLoaded: true, entities: action.payload };
    case ProActionTypes.GetProNodesBankFailure:
      return {...state, isLoading: false, isLoaded: true };
    default:
      return state;
  }
}
